export default __webpack_public_path__ + "0cf4028c938dc353fd5166e208e23f96.jpg";